import React from 'react';
import { Gift } from 'lucide-react';
import { Reveal } from '../ui/Reveal';
const bonos = [{
  title: 'BONO 1 — El Diccionario Secreto de tu Bebé',
  problem: 'Tu bebé ya intenta comunicarse con vos. Solo que todavía no usa palabras.',
  desc: 'Aprendé a interpretar sus gestos, expresiones, miradas y tipos de llanto para entender lo que necesita mucho antes de que pueda decirlo.',
  result: 'Vas a entender mejor a tu bebé incluso antes de sus primeras palabras.'
}, {
  title: 'BONO 2 — Método Pantallas Cero',
  problem: 'Cuando no sabés qué hacer, el celular termina siendo la salida más fácil.',
  desc: 'Descubrí un plan práctico para reducir las pantallas sin berrinches, reemplazándolas por actividades simples que realmente mantienen a tu hijo entretenido.',
  result: 'Vas a dejar de depender del celular para entretener a tu hijo.'
}, {
  title: 'BONO 3 — Guía de Supervivencia Familiar',
  problem: 'Todos opinan sobre tu hijo... aunque nadie esté en tu lugar.',
  desc: 'Aprendé a responder con tranquilidad a las comparaciones y comentarios de familiares, y descubrí cómo convertirlos en aliados del desarrollo del habla.',
  result: 'Vas a sentirte mucho más segura frente a las opiniones de los demás.'
}, {
  title: 'BONO 4 — Comer, Hablar y Jugar',
  problem: 'El desarrollo del habla también empieza por la boca.',
  desc: 'Descubrí juegos simples de soplido, masticación y movimiento que fortalecen las habilidades orales de forma divertida y natural.',
  result: 'Vas a complementar la estimulación del habla con actividades que fortalecen sus bases.'
}, {
  title: 'BONO 5 — Jardín sin Miedo',
  problem: 'El primer día de jardín es mucho más fácil cuando un niño sabe comunicarse.',
  desc: 'Prepará a tu hijo para expresar lo que necesita, pedir ayuda y relacionarse con mayor seguridad antes de empezar esta nueva etapa.',
  result: 'Vas a ayudar a que llegue al jardín con más confianza para comunicarse.'
}, {
  title: 'BONO 6 — Diario del Desarrollo del Habla',
  problem: 'Los primeros avances pasan muy rápido... y merecen ser recordados.',
  desc: 'Registrá cada palabra, cada hito y cada logro del desarrollo del lenguaje en una bitácora que también te servirá para seguir su evolución.',
  result: 'Vas a conservar un recuerdo único mientras seguís de cerca el progreso de tu hijo.'
}];
export function Bonuses() {
  return <section className="py-12 px-5 bg-violet-50" data-id="element-31">
      <div className="text-center mb-10" data-id="element-32">
        <div className="inline-flex items-center justify-center bg-violet-200 p-3 rounded-full mb-4" data-id="element-33">
          <Gift className="w-8 h-8 text-violet-700" data-id="element-34" />
        </div>
        <h2 className="text-3xl font-extrabold text-gray-900 mb-4" data-id="element-35">
          Y eso no es todo.
        </h2>
        <p className="text-lg text-gray-700" data-id="element-36">
          Si comprás el Ultrapack hoy, recibís estos{' '}
          <span className="font-bold text-violet-700" data-id="element-37">
            6 bonos sin costo adicional
          </span>
          :
        </p>
      </div>

      <div className="space-y-6 mb-12" data-id="element-38">
        {bonos.map((bono, index) => <Reveal key={index} delay={Math.min(index * 0.05, 0.25)} data-id="element-39">
            <div className="bg-white rounded-2xl p-6 shadow-sm border-2 border-violet-100 relative overflow-hidden transition-shadow hover:shadow-md" data-id="element-40">
              <div className="absolute top-0 right-0 bg-green-500 text-white text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-41">
                GRATIS
              </div>
              <h3 className="font-bold text-xl text-gray-900 mb-4 pr-20 mt-2" data-id="element-42">
                {bono.title}
              </h3>

              <p className="text-gray-700 text-sm italic mb-4" data-id="element-43">
                "{bono.problem}"
              </p>

              <p className="text-gray-600 text-sm mb-4 leading-relaxed" data-id="element-44">
                {bono.desc}
              </p>

              <div className="bg-violet-50 p-3 rounded-lg border border-violet-100" data-id="element-45">
                <p className="text-sm font-bold text-violet-800" data-id="element-46">
                  ✨ {bono.result}
                </p>
              </div>
            </div>
          </Reveal>)}
      </div>
    </section>;
}